import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { formatCountNumber2digit, toPascalCase, valdiatePage } from '../../global';
import { paymentinstrumentdetailreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { getLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';

export const ibftConsignmentColumns = [
  { label: "Consignment Number", key: "consignmentNumber" },
  { label: "Order Ref No", key: "orderRefNo" },
  { label: "Booking Date", key: "bookingDate" },
  { label: "RR Date", key: "rrDate" },
  { label: "Consignee", key: "consignee" },
  { label: "Location Name", key: "locationName" },
  { label: "Location ID", key: "locationID" },
  { label: "Branch", key: "locationBranchName" },
  { label: "Zone", key: "zoneName" },
  { label: "Origin", key: "origin" },
  { label: "Destination", key: "destination" },
  { label: "Weight", key: "weight" },
  { label: "CN Status", key: "cnStatus" },
  { label: "COD Amount", key: "codAmount" },
  { label: "Shipping Charges", key: "shippingCharges" },
  { label: "Invoice Amount", key: "cnWiseInvoiceAmount" },
  { label: "Taxable Amount", key: "taxAbleAmount" },
  { label: "Income Tax Amount", key: "incomeTaxAmount" },
  { label: "Sales Tax Amount", key: "salesTaxAmount" },
  { label: "WTH Tax", key: "wthTax" }
];

const PaymentInstrumentDetailReport = () => {
    const dispatch = useDispatch();
    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;

    const history = useHistory();

    const d = { 'PaymentID': '' };
    const [grid, setGrid] = useState([]);
    const [data, setData] = useState(d);

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState({});
    
    const searchObjInit = {
        consignmentNumber: '',
        orderRefNo: '',
        consignee: '',
        bookingDate: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: 'consignmentNumber', name: 'CN', searchBox: true, visible: true},
        {key: 'orderRefNo', name: 'Cust Ref#', searchBox: true, visible: true},
        {key: 'bookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {key: 'rrDate', name: 'Receipt Date', searchBox: false, visible: true},
        {key: 'consignee', name: 'Consignee', searchBox: true, visible: true},        
        {key: 'locationName', name: 'Location Name', searchBox: true, visible: true},
        {key: 'locationID', name: 'Location ID', searchBox: true, visible: true},
        {key: 'locationBranchName', name: 'Branch', searchBox: true, visible: true},
        {key: 'zoneName', name: 'Zone', searchBox: true, visible: true},
        {key: 'origin', name: 'Origin', searchBox: false, visible: true},
        {key: 'destination', name: 'Destination', searchBox: false, visible: true},
        {key: 'weight', name: 'Weight', searchBox: false, visible: true},
        {key: 'cnStatus', name: 'Status', searchBox: false, visible: true},
        {key: 'codAmount', name: 'COD Amt', searchBox: false, visible: true},
        {key: 'shippingCharges', name: 'Shipping Charges', searchBox: false, visible: true},
        {key: 'cnWiseInvoiceAmount', name: 'Invoice Amount', searchBox: false, visible: true},
        {key: 'taxAbleAmount', name: 'Taxable Amount', searchBox: false, visible: true},
        {key: 'incomeTaxAmount', name: 'Income Tax Amount', searchBox: false, visible: true},
        {key: 'salesTaxAmount', name: 'Sales Tax Amount', searchBox: false, visible: true},
        {key: 'wthTax', name: 'WTH Tax', searchBox: false, visible: true},

    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (!valdiatePage('/paymentinstrument')) {
            history.push('/login');
        }
    }, []);


    window.onload = async function (e) {
        const paymentid = JSON.parse(sessionStorage.getItem('paymentInstrumentDetail'));
        sessionStorage.removeItem('paymentInstrumentDetail');

        if (!paymentid) {
            alert('No Payment ID found');
            return;
        }

        dispatch(setLoading({ data: true }));
        data.PaymentID = paymentid;
        var rs = await paymentinstrumentdetailreport(data);
        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
                setGrid(rs.data.consignments);
                setOriginalGrid(rs.data);

            
        } else {
            alert(rs.msg);
            setGrid([]);
            setOriginalGrid({});
        }
    }
    return <section className="section">
        <div className="section-header">
            <h1>Payment Instrument Detail Report</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            {
                originalGrid?.consignments?.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <div className="row" style={{ fontSize: 12 }}>
                            <div className="col-7">
                                <table width="100%" >
                                    <tbody style={{ color: "#8c8c8e" }}>
                                        <tr>
                                            <td colSpan="1"><b>Account#</b></td>
                                            <td colSpan="1">{originalGrid?.clientInfo.accountNo}</td>
                                            <td colSpan="1"><b>Payment ID</b></td>
                                            <td colSpan="1">{data?.PaymentID}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Customer</b></td>
                                            <td colSpan="">{originalGrid?.clientInfo.clientName}</td>
                                            <td colSpan="1"><b>Print Date/Time</b></td>
                                            <td colSpan="">{new Date().toLocaleString()}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>City</b></td>
                                            <td colSpan="1">{originalGrid?.clientInfo.city}</td>
                                            <td colSpan="1"><b>Beneficiary Name</b></td>
                                            <td colSpan="1">{originalGrid?.clientInfo.beneficiaryName}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Payment Period</b></td>
                                            <td colSpan="1">{new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "short",
                                                day: "2-digit"
                                            }).format(new Date(originalGrid?.clientInfo.minPaymentPeriod))} to {new Intl.DateTimeFormat("en-GB", {
                                                year: "numeric",
                                                month: "short",
                                                day: "2-digit"
                                            }).format(new Date(originalGrid?.clientInfo.maxPaymentPeriod))}</td>
                                            <td colSpan="1"><b>Beneficiary Bank Acc#</b></td>
                                            <td colSpan="1">{originalGrid?.clientInfo.beneficiaryBankAccNo}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Bank Name: </b></td>
                                            <td colSpan="1">{originalGrid?.clientInfo.bank_Name}</td>
                                            <td colSpan="1"><b>SBP Code</b></td>
                                            <td colSpan="1">{originalGrid?.clientInfo.sbpCode}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-5" style={{ textAlign: 'left' }} >
                                <table width="100%">
                                    <tbody style={{ color: "#8c8c8e" }}>
                                        <tr>
                                            <td colSpan="2" style={{ color: "#8c8c8e" }}><b>INVOICE SUMMARY</b></td>
                                            <td colSpan="2" style={{ color: "#8c8c8e" }}><b>PAYMENT SUMMARY</b></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Shipping Charges</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.invoiceSummary.shipmentCharge || 0)}</td>
                                            <td colSpan="1"><b>Total COD Amount</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.paymentHead.totalCODAmount || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Fuel Surcharge</b></td>
                                            <td colSpan="">{formatCountNumber2digit(originalGrid?.invoiceSummary.fuel_Charge || 0)}</td>
                                            <td colSpan="1"><b>WH Tax</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.paymentHead.whTax || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>GST: </b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.invoiceSummary.gst || 0)}</td>
                                            <td colSpan="1"><b>Credit Note</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.invoiceSummary.creditNote || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Extra Charge</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.invoiceSummary.extraCharges || 0)}</td>
                                            <td colSpan="1"><b>Claim Credit Note</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.paymentHead.claimCreditNoteAmount || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>OSA/NSA Charges</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.osansa.osansa_Amount || 0)}</td>
                                            <td colSpan="1"><b>Net Payable</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(Number(originalGrid?.paymentHead.netPayable || 0) + Number(originalGrid?.paymentHead.claimCreditNoteAmount || 0) + Number(originalGrid?.invoiceSummary.creditNote || 0))}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>OSA/NSA GST</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.osansa.osansa_gst || 0)}</td>
                                            <td colSpan="1"><b>Returned to Shipper</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.rts.rtsAmount || 0)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="1"><b>Total Invoice Amount</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.paymentHead.invoiceAmount || 0)}</td>
                                            <td colSpan="1"><b>Debit Note Charges</b></td>
                                            <td colSpan="1">{formatCountNumber2digit(originalGrid?.debitNote?.debitNoteCharges || 0)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                            <p style={{ color: "#8c8c8e" }}> <b>Invoice Numbers: </b> {originalGrid.invoices.map(x => x.value).join(',')}</p>
                        </div>
                        <br />
                        <div style={{ textAlign: 'right' }}>
                            {/* <ExportExcelIBFT data={originalGrid[3]} /> */}
                              <ExportExcelButton data={originalGrid.consignments} columns={ibftConsignmentColumns} fileName="IBFTCondignmentReport"
                                />
                        </div>
                        <br />

                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid.consignments}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                <>
                                    {sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                            <Fragment key={index}>
                                                <tr key={index}>
                                                    <td>{(index + 1)+(page*pageLimit)}</td>
                                                    <td>{x.consignmentNumber}</td>
                                                    <td>{x.orderRefNo}</td>
                                                    <td>{x.bookingDate}</td>
                                                    <td>{x.rrDate}</td>
                                                    <td>{x.consignee}</td>
                                                    <td>{x.locationName}</td>
                                                    <td>{x.locationID}</td>
                                                    <td>{toPascalCase(x.locationBranchName)}</td>
                                                    <td>{x.zoneName}</td>
                                                    <td>{x.origin}</td>
                                                    <td>{x.destination}</td>
                                                    <td>{x.weight}</td>
                                                    <td>{x.cnStatus}</td>
                                                    <td>{x.codAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.shippingCharges.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.cnWiseInvoiceAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.taxAbleAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.incomeTaxAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.salesTaxAmount.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                    <td>{x.wthTax.toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</td>
                                                                        
                                                </tr>
                                            </Fragment>
                                        )}
                                    <tr>
                                        <td></td>
                                        <td><b>Grand Total: </b></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td><b>{(originalGrid.consignments.reduce((acc, current) => acc + current.weight, 0)).toFixed(2)}</b></td>
                                        <td></td>
                                        <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.codAmount, 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>
                                        <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.shippingCharges , 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>


                                        <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.cnWiseInvoiceAmount, 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>
                                        <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.taxAbleAmount, 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>
                                        <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.incomeTaxAmount, 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>
                                        <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.salesTaxAmount, 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>
   <td><b>{Math.round(originalGrid.consignments.reduce((acc, current) => acc + current.wthTax, 0), 0).toLocaleString('ur-PK', {
                                                                        style: 'currency',
                                                                        currency: 'PKR',
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2,
                                                                        })}</b></td>
                                    </tr>
                                </>
                            }
                        />

                    </div>
                </div>
            }
        </div>
    </section>
}

export default PaymentInstrumentDetailReport;